export default __webpack_public_path__ + "static/emailrightplain-516cfde59c61334325e7b183a0bdd633.svg";